import React, { useContext, useState, useEffect } from "react";
import { UmbracoContext, UmbracoStep } from "components/Umbraco/UmbracoContext";
import { InnerMedium, Row, SetMainCond, StepHeader } from "meitav-uikit";
import { Parser } from "html-to-react";

import "styles/_uikit-overrides.scss";

import utils from "utils";
import Step10 from "./Steps/Step10";
import Step11 from "./Steps/Step11";
import Step21 from "./Steps/Step21";
import Step22 from "./Steps/Step22";
import Step23 from "./Steps/Step23";
import Step31 from "./Steps/Step31";
import Step32 from "./Steps/Step32";
import Step33 from "./Steps/Step33";
import Step34 from "./Steps/Step34";
import Step41 from "./Steps/Step41";
import Step42 from "./Steps/Step42";
import Step43 from "./Steps/Step43";
import Step44 from "./Steps/Step44";
import Step99 from "./Steps/Step99";

import { saveModel } from "../../../utils/Functions";

const { UmbracoUtills, rest } = utils;

const MultiStepForm = (props) => {
  const disabled = localStorage.getItem("Disabled") == "True";

  const [dataList, setDataList] = useState({
    banks: [],
    branches: [],
    cities: [],
    agent: [],
    minDepositSum: "",
    digitalFile: {
      tazType: "2",
      fileList: {},
      partnerFiles: {},
    },
  });
  const [model, setModel] = useState(
    JSON.parse(window.localStorage.getItem("model")) || {
      stepID: 10,
      currentStepID: 10,
      processId: "",
      sectorCode: "",
      sectorName: "",
      riskLevelName: "",
      joinInvestPolicyIDOld: "",
      joinInvestPolicyID: "",
      isShowPopupBenefittor: "",
      isExistingProcess: "",
      existingProcessStep: "",
      isJoinInvestPolicyOld: false,
      utm_medium: "",
      utm_source: "",
      ga_Info: {
        cid: "",
        gclid: "",
        dclid: "",
        fbclid: "",
        visitorKey: "",
      },
      mainUser: {
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        iDNumber: "",
        birthDate: "",
        gender: "",
        commonBankAccount: "",
        commonBankAccountFlag: "",
        asInvestPartner: "",
        isAllowSMSandEmail: null,
        marketingAgreement: null,
        maritalStatus: "",
        birthCountry: "",
        israeliResidency: "",
        israeliCitizenship: "",
        americanCitizenship: "",
        americanTax: "",
        foreignNonAmercanTax: "",
        cityText: "",
        street: "",
        house: "",
        apartment: "",
        zipCode: "",
        isMailElseWhere: false,
        cityMail: "",
        streetMail: "",
        houseMail: "",
        apartmentMail: "",
        zipCodeMail: "",
      },
      bankPartner: {
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        taz: "",
        birthDate: "",
        gender: "",
        birthCountry: "",
        israeliResidency: "",
        israeliCitizenship: "",
        americanCitizenship: "",
        americanTax: "",
        foreignNonAmercanTax: "",
        relationshipTypeID: "",
      },
      benefittor: {
        benefittorStatmentId: "",
        benefittors: [],
        promisesToUpdateBenifittor: "",
      },

      filesUpload: "",
      fileRequired: true,
      paymentDetails: {
        depositTypeId: "",
        permitionTypeId: "",
        isBigBank: "",
        depositBankNum: "",
        depositBankName: "",
        depositBankSnif: "",
        depositBankSnifName: "",
        depositBankAccountNum: "",
        depositBankAccountFullName: "",
        agentCode: "",
        bankSiteURL: "",
        depositSum: "",
        bankTransferCheckBox: false,
        bankDigitalDepositCheckBox: false,
        bankPermisionSumCheckBox: false,
        bankPermisionDateCheckBox: false,
        restrictionMaxSum: "",
        restrictionUntillDate: "",
        //signatureMinPix: "",
        depositSumChange: false,
        signature: "",
        //filesUpload: "",
        //errorAgentCode: false,
        // errorRestrictionMaxSum: false,
        // errorRestrictionUntillDate: false,
      },
    }
  );

  const p = new Parser();
  const noHeader = [11, 99];
  const resource = useContext(UmbracoContext).resource;
  const resourceError = UmbracoStep(resource, `Validation`);
  const [step, setStep] = useState(10);
  const [title, setTitle] = useState("");
  const [icon, setIcon] = useState("");
  const [rate, setRate] = useState(0);
  const [subTitle, setSubTitle] = useState("");
  const [subIcon, setSubIcon] = useState("");
  const [stepDesc, setStepDesc] = useState("");
  const [disable, setDisable] = useState(false);

  const [recapchaKey, setRecapchaKey] = useState("");

  useEffect(() => {
    // if (window.localStorage.getItem("finishSession") == 'true') {
    //  setStep(0);
    // }
    /// else {
    getRecapchaKey();
    setCondMsg();
    if (window.localStorage.getItem("Disabled") === "True") {
      setDisable(true);
      const tmpModel = JSON.parse(window.localStorage.getItem("model"));
      if (tmpModel != null) {
        setStep(tmpModel.stepID);

        setModel(tmpModel);
        saveModel(tmpModel, tmpModel.stepID);
      }
    } else {
      checkIfProcessExist();
    }
  }, []);

  const setCondMsg = () => {
    const obj = {
      empty: UmbracoUtills.getValueByKey(resourceError, "required"),
      must: UmbracoUtills.getValueByKey(resourceError, "required"),
      minLength: UmbracoUtills.getValueByKey(resourceError, "minLength"),
      hebrew: UmbracoUtills.getValueByKey(resourceError, "hebrewError"),
      onlyHebrew: UmbracoUtills.getValueByKey(resourceError, "hebrewError"),
      onlyDigits: UmbracoUtills.getValueByKey(resourceError, "numberError"),
      date: UmbracoUtills.getValueByKey(resourceError, "invalidDate"),
      email: UmbracoUtills.getValueByKey(resourceError, "emailNotValid"),
      phone: UmbracoUtills.getValueByKey(resourceError, "mobilePhoneIsValid"),
      identity: UmbracoUtills.getValueByKey(resourceError, "iDNumberNotValid"),
    };

    SetMainCond(obj);
  };

  const getRecapchaKey = async () => {
    await rest.get("/api/manager/GetRecapchaKey").then((res) => {
      setRecapchaKey(res.data);
      // recaptcha
      const recapchaScript = document.createElement("script");
      recapchaScript.src = `https://www.google.com/recaptcha/enterprise.js?render=${res.data}`;

      recapchaScript.async = true;
      recapchaScript.defer = true;
      document.head.appendChild(recapchaScript);
    });
  };

  const checkIfProcessExist = () => {
    const processId = window.localStorage.getItem("processGuid");
    if (processId && processId != "undefined") {
      const tmpModel = JSON.parse(window.localStorage.getItem("model"));
      if (tmpModel?.stepID > 11) rest.get(`/api/Manager/CheckProcessIsvalid`);
      if (tmpModel?.stepID == 99) {
        localStorage.clear();
        window.location.href = "/CustomerInvestPolicy";
        return;
      }
      tmpModel.processId = processId;
      var tmpStep = tmpModel?.stepID == 11 ? 10 : tmpModel?.stepID;

      setModel(tmpModel);
      setStep(tmpStep);
      saveModel(tmpModel, tmpStep);
      getAgentsList();
    }
    //window.location.href = "/CustomerInvestPolicy";
    else setStep(10);
    if (window.localStorage.getItem("dataList") != null)
      setDataList(JSON.parse(window.localStorage.getItem("dataList")));
  };
  const getAgentsList = async () => {
    const t = await rest.get(`/api/Manager/getAgents`);
    // setAgentList(t.data);
    let tmpList = dataList;
    tmpList.agent = t?.data;
    setDataList(tmpList);
    localStorage.setItem("dataList", JSON.stringify(tmpList));
  };
  const renderStep = () => {
    switch (step) {
      case 10:
        return "FirstSub1Step";
      case 11:
        return "PopUpOtp";
      case 21:
        return "FirstSub2Step";
      case 22:
        return "FirstSub3Step";
      case 23:
        return "FirstSub4Step";
      case 31:
        return "SecondSub1Step";
      case 32:
        return "SecondSub2Step";
      case 33:
        return "SecondSub3Step";
      case 34:
        return "SecondSub4Step";
      case 41:
        return "ThirdSub1Step";
      case 42:
        return "ThirdSub2Step";
      case 43:
        return "ThirdSub3Step";
      case 44:
        return "ThirdSub44Step";
      case 99:
        return "ThirdSub4Step";
      default:
        return "";
    }
  };
  const renderRate = () => {
    switch (step) {
      case 10:
      case 11:
      case 21:
      case 22:
      case 23:
        return 25;
      case 31:
      case 32:
      case 34:
        return 50;
      case 41:
      case 42:
      case 43:
      case 44:
        return 75;
      case 99:
        return 100;
      default:
        return "";
    }
  };

  const renderTitle = () => {
    const resoursSteps = UmbracoUtills.getValueByKeyLp(resource, "stepsTitle");
    const stepperSteps = resoursSteps
      ?.substr(0, resoursSteps.length - 1)
      ?.substr(1)
      ?.replace(/"/g, "")
      ?.split(",");

    if (stepperSteps != null) {
      switch (step) {
        case 10:
        case 11:
        case 21:
        case 22:
        case 23:
          return stepperSteps[0];
        case 31:
        case 32:
        case 33:
        case 34:
          return stepperSteps[1];
        case 41:
        case 42:
        case 43:
        case 44:
        case 99:
          return stepperSteps[2];
        default:
          return "";
      }
    } else return null;
  };
  useEffect(() => {
    let stepOld = renderStep();
    let rate = renderRate();
    let textTilte = renderTitle();
    const resourceStep = UmbracoStep(resource, `${stepOld}`);
    setTitle(`${textTilte}`);
    setIcon(UmbracoUtills.getValueByKey(resourceStep, "icon"));
    setRate(`${rate}`);
    setSubTitle(UmbracoUtills.getValueByKey(resourceStep, "title"));
    setSubIcon(UmbracoUtills.getValueByKey(resourceStep, "subIcon"));
    setStepDesc(UmbracoUtills.getValueByKey(resourceStep, "subTitle"));

    /*if (step == 11) {
        setStepDesc(UmbracoUtills.getValueByKey(resourceStep, 'description').replace("@itemName", model.mainUser.depositTypeName));
      }
      if (step == 41) {
        setSubTitle(UmbracoUtills.getValueByKey(resourceStep, "subTitle").replace("@name", `${model.mainUser.firstName} ${model.mainUser.lastName}`));
      }*/
  }, [step]);

  const renderComponent = () => {
    switch (step) {
      case 0:
        return <></>;
      case 10:
        return (
          <Step10
            resource={resource}
            model={model}
            nextText={UmbracoUtills.getValueByKeyLp(resource, "buttonContinue")}
            setModel={setModel}
            setStep={setStep}
            step={step}
            recapchaKey={recapchaKey}
            resourceError={resourceError}
          />
        );
      case 11:
        return (
          <Step11
            resource={resource}
            model={model}
            nextText={UmbracoUtills.getValueByKeyLp(resource, "buttonContinue")}
            setModel={setModel}
            setStep={setStep}
            step={step}
            recapchaKey={recapchaKey}
            resourceError={resourceError}
          />
        );
      case 21:
        return (
          <Step21
            resource={resource}
            model={model}
            nextText={UmbracoUtills.getValueByKeyLp(resource, "buttonContinue")}
            setModel={setModel}
            setStep={setStep}
            step={step}
            recapchaKey={recapchaKey}
            resourceError={resourceError}
            disable={disable}
          />
        );
      case 22:
        return (
          <Step22
            resource={resource}
            model={model}
            nextText={UmbracoUtills.getValueByKeyLp(resource, "buttonContinue")}
            setModel={setModel}
            setStep={setStep}
            step={step}
            dataList={dataList}
            setDataList={setDataList}
            resourceError={resourceError}
            disable={disable}
          />
        );
      case 23:
        return (
          <Step23
            resource={resource}
            model={model}
            nextText={UmbracoUtills.getValueByKeyLp(resource, "buttonContinue")}
            setModel={setModel}
            setStep={setStep}
            step={step}
            dataList={dataList}
            setDataList={setDataList}
            resourceError={resourceError}
            disable={disable}
          />
        );
      case 31:
        return (
          <Step31
            resource={resource}
            model={model}
            nextText={UmbracoUtills.getValueByKeyLp(resource, "buttonContinue")}
            setModel={setModel}
            setStep={setStep}
            step={step}
            dataList={dataList}
            setDataList={setDataList}
            resourceError={resourceError}
            disable={disable}
          />
        );
      case 32:
        return (
          <Step32
            disable={disable}
            resource={resource}
            model={model}
            nextText={UmbracoUtills.getValueByKeyLp(resource, "buttonContinue")}
            setModel={setModel}
            setStep={setStep}
            step={step}
            dataList={dataList}
            setDataList={setDataList}
            resourceError={resourceError}
          />
        );
      case 33:
        return (
          <Step33
            resource={resource}
            disable={disable}
            model={model}
            nextText={UmbracoUtills.getValueByKeyLp(resource, "buttonContinue")}
            setModel={setModel}
            setStep={setStep}
            step={step}
            dataList={dataList}
            setDataList={setDataList}
            resourceError={resourceError}
          />
        );
      case 34:
        return (
          <Step34
            disable={disable}
            resource={resource}
            model={model}
            nextText={UmbracoUtills.getValueByKeyLp(resource, "buttonContinue")}
            setModel={setModel}
            setStep={setStep}
            step={step}
            dataList={dataList}
            setDataList={setDataList}
            resourceError={resourceError}
          />
        );
      case 41:
        return (
          <Step41
            disable={disable}
            resource={resource}
            model={model}
            nextText={UmbracoUtills.getValueByKeyLp(resource, "buttonContinue")}
            setModel={setModel}
            setStep={setStep}
            step={step}
            dataList={dataList}
            setDataList={setDataList}
            resourceError={resourceError}
          />
        );
      case 42:
        return (
          <Step42
            disable={disable}
            resource={resource}
            model={model}
            nextText={UmbracoUtills.getValueByKeyLp(resource, "buttonContinue")}
            setModel={setModel}
            setStep={setStep}
            step={step}
            dataList={dataList}
            setDataList={setDataList}
            resourceError={resourceError}
          />
        );
      case 43:
        return (
          <Step43
            disable={disable}
            resource={resource}
            model={model}
            nextText={UmbracoUtills.getValueByKeyLp(resource, "buttonContinue")}
            setModel={setModel}
            setStep={setStep}
            step={step}
            dataList={dataList}
            setDataList={setDataList}
            resourceError={resourceError}
          />
        );
      case 44:
        return (
          <Step44
            disable={disable}
            resource={resource}
            model={model}
            nextText={UmbracoUtills.getValueByKeyLp(resource, "buttonContinue")}
            setModel={setModel}
            setStep={setStep}
            step={step}
            dataList={dataList}
            setDataList={setDataList}
            resourceError={resourceError}
          />
        );
      case 99:
        return (
          <Step99
            resource={resource}
            model={model}
            nextText={UmbracoUtills.getValueByKeyLp(resource, "buttonContinue")}
            setModel={setModel}
            setStep={setStep}
            step={step}
            dataList={dataList}
            setDataList={setDataList}
            resourceError={resourceError}
          />
        );
      default:
        return <></>;
    }
  };

  return (
    <InnerMedium className="multistepForm">
      <Row type="large">
        {noHeader.includes(step) ? null : (
          <StepHeader
            title={title}
            rate={rate}
            rateLabel="מיקומך בתהליך הצטרפות"
            subTitle={subTitle}
            description={p.parse(stepDesc)}
          />
        )}
        {renderComponent()}
      </Row>
    </InnerMedium>
  );
};

export default MultiStepForm;
